import { runAction } from 'b24network.security.flowtoken';

export class ComponentTransport
{
	query(action, data)
	{
		return runAction(action, data);
	}
}
